const MembershipServiceApp = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../MembershipServiceApp.vue"
  );
const Home = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/Home.vue"
  );
const MembershipManage = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/MembershipManage.vue"
  );
const MembershipSetting = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/MembershipSetting.vue"
  );
const MembershipReSetting = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/MembershipReSetting.vue"
  );
const MembershipStep = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/MembershipStep.vue"
  );
const MembershipReStep = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/MembershipReStep.vue"
  );
const User = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/User.vue"
  );
const Order = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/Order.vue"
  );
const SmsAlarmSetting = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/SmsAlarmSetting.vue"
  );
import ServiceInit from "../views/membership/ServiceInit.vue";

const ServiceIntro = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/ServiceIntro.vue"
  );

const Payment = () =>
  import(
    /* webpackChunkName: "MembershipService" */ "../views/membership/Payment.vue"
  );

import AdditionalService from "../views/membership/AdditionalService.vue";

export const CAFE24_ROUTES = [
  {
    path: "/",
    name: "BasicHome",
    redirect: {
      name: "MembershipServiceApp",
    },
  },
  {
    path: "/membership",
    redirect: {
      name: "ServiceInit",
    },
    name: "MembershipServiceApp",
    component: MembershipServiceApp,
    children: [
      {
        path: "/membership/init",
        name: "ServiceInit",
        component: ServiceInit,
      },
      {
        path: "/membership/:mall_id/serviceIntro",
        name: "ServiceIntro",
        component: ServiceIntro,
        props: true,
      },
      {
        path: "/membership/:mall_id/Home",
        name: "Home",
        component: Home,
      },
      {
        path: "/membership/:mall_id/membershipManage",
        name: "MembershipManage",
        component: MembershipManage,
      },
      {
        path: "/membership/:mall_id/membershipSetting",
        name: "MembershipSetting",
        component: MembershipSetting,
      },
      {
        path: "/membership/:mall_id/membershipReSetting",
        name: "MembershipReSetting",
        component: MembershipReSetting,
      },
      {
        path: "/membership/:mall_id/user",
        name: "User",
        component: User,
      },
      {
        path: "/membership/:mall_id/order",
        name: "Order",
        component: Order,
      },
      {
        path: "/membership/:mall_id/smsAlarmSetting",
        name: "SmsAlarmSetting",
        component: SmsAlarmSetting,
      },
      {
        path: "/membership/:mall_id/payment",
        name: "Payment",
        component: Payment,
        props: true,
      },
      {
        path: "/membership/:mall_id/additionalService",
        name: "AdditionalService",
        component: AdditionalService,
        props: true,
      },
      {
        path: "/membership/:mall_id/membershipStep",
        name: "MembershipStep",
        component: MembershipStep,
      },
      {
        path: "/membership/:mall_id/MembershipReStep",
        name: "MembershipReStep",
        component: MembershipReStep,
      },
    ],
  },
];
